import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell } from "recharts";




export default function PCcat2(count) {
    const [category, setCategory] = useState("");
    const [value, setValue] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let sum = 0;

        count.data.forEach((item) => {
            sum += Number(item.total_count);
        });

        setTotal(sum);

        setCategory(count.data[1]?.category)
        setValue(Number(count.data[1]?.total_count))

    }, [value, category, count])


    const data = [
        { name: category, value: value },
        { name: "Others", value: (total - value) }
    ];
    
    const COLORS = ["#5AA8DC", "#5AA8DC30"];
    
    return (
        <div className="d-flex align-items-center col-12 col-sm-6 p-0">
            <PieChart width={100} height={100}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={30}
                    outerRadius={40}
                    startAngle={90}
                    endAngle={-270}
                    fill="blue"
                    paddingAngle={0}
                    dataKey="value"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
            </PieChart>
            <span>
                <p>{category}</p>
                <h5>{`${value}/${total}`}</h5>
            </span>
        </div>

    );
}
